import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import Checkbox from './Checkbox'
import Example from './Example'
import Panel from './Panel'

import { checkRule } from '../../actioncreators/actioncreators'

const RuleContainer = styled.div`
  flex-grow: 1;
`

const RuleText = styled.pre`
  border: solid 5px #0C8CE6;
  border-width: 0 0 0 5px;
  border-radius: 0;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-weight: bold;
  font-family: sans-serif;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #fff;
`

const Rules = () => {
  const dispatch = useDispatch()
  const rules = useSelector(state => state.rules)

  return rules.flat().map(rule =>
    <Panel key={rule.id}>
      <div style={{ display: 'flex' }}>
        <RuleContainer>
          <RuleText>{rule.text || String.fromCharCode(160)}</RuleText>
          <div>
            {rule.examples.map(example =>
              <Example key={example.id}>{example.text || String.fromCharCode(160)}</Example>
            )}
          </div>
        </RuleContainer>
        <Checkbox onChange={() => dispatch(checkRule(rule.id))} checked={rule.checked} />
      </div>
    </Panel>
  )
}

export default Rules
